import { useState } from 'react';
import { saveSucceeded } from '@/shared/lib/saveSucceeded';
import { Modal } from '../../atoms/Modal';
import { ModalFooter } from '../../molecules/ModalFooter';
import * as s from './ProofRejectModal.css';

export interface ProofRejectModalProps {
  open: boolean;
  onClose: () => void;
  /** 저장 약속을 돌려주면 성공해야 사유 칸을 비운다. 실패하면 입력이 남는다. */
  onConfirm: (comment: string) => void | Promise<unknown>;
  proofTitle?: string;
  submitterName?: string;
  loading?: boolean;
}

export function ProofRejectModal({
  open,
  onClose,
  onConfirm,
  proofTitle,
  submitterName,
  loading = false,
}: ProofRejectModalProps) {
  const [comment, setComment] = useState('');

  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    if (!comment.trim() || saving) return;
    setSaving(true);
    try {
      if (await saveSucceeded(() => onConfirm(comment.trim()))) setComment('');
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    setComment('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="증빙 반려"
      footer={
        <ModalFooter
          primaryVariant="danger"
          primaryLabel="반려"
          onPrimaryClick={() => void handleConfirm()}
          onSecondaryClick={handleClose}
          loading={loading || saving}
          primaryDisabled={!comment.trim()}
        />
      }
    >
      <div className={s.content}>
        {(proofTitle || submitterName) && (
          <div className={s.info}>
            {submitterName && <span className={s.submitter}>{submitterName}</span>}
            {proofTitle && <span className={s.proofTitle}>{proofTitle}</span>}
          </div>
        )}
        <label className={s.label} htmlFor="proof-reject-reason">
          반려 사유 <span className={s.required}>*</span>
        </label>
        <textarea
          id="proof-reject-reason"
          className={s.textarea}
          placeholder="반려 사유를 입력해주세요. 팀원에게 전달됩니다."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
          maxLength={500}
        />
        <div className={s.charCount}>{comment.length}/500</div>
      </div>
    </Modal>
  );
}

export default ProofRejectModal;
